declare function require(module: string): any;

import { PosttestCard, PretestReviewCard } from '@holmescorp/card';
import { registry } from 'lcc-state';
import { MCSelector } from 'quiz-widgets/questions/mc-selector';
import { register_base_lp_widgets } from '../../shared/init/lp-init';

export function register_lp_widgets(): void {
	register_base_lp_widgets();

	// widgets for additional resources carousel
	registry.define('PosttestCard', PosttestCard);
	registry.define('PretestReviewCard', PretestReviewCard);

	registry.define('AskTheInstructor', (): Promise<any> => {
		return Promise.resolve(require('ask-the-instructor').AskTheInstructor);
	});
	registry.define('Announcements', (): Promise<any> => {
		return Promise.resolve(require('announcements').Announcements);
	});
	registry.define('ClassRoster', (): Promise<any> => {
		return Promise.resolve(require('class-roster').ClassRoster);
	});
	registry.define('Editor', (): Promise<any> => {
		return Promise.resolve(require('editor-widget').Editor);
	});

	// setup casestudy to use multiple choice instead
	registry.define('MicroQuiz', MCSelector);
}
